module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Localidade'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da localidade ou instituição",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.localidade.nome),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "nome", $$v)
      },
      expression: "localidade.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Estado",
      "items": _vm.listaEstados,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    on: {
      "change": function($event) {
        return _vm.atualizaCidades($event)
      }
    },
    model: {
      value: (_vm.localidade.ufCidade),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "ufCidade", $$v)
      },
      expression: "localidade.ufCidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Município",
      "items": _vm.listaCidades,
      "item-text": "nomeCidade",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.localidade.cidade),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "cidade", $$v)
      },
      expression: "localidade.cidade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaCidadesSelecionadas.length < 2) ? _c('v-text-field', {
    attrs: {
      "label": "CEP",
      "max-height": "400"
    },
    model: {
      value: (_vm.localidade.cep),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "cep", $$v)
      },
      expression: "localidade.cep"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Informações adicionais",
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.localidade.detalhes),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "detalhes", $$v)
      },
      expression: "localidade.detalhes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarLocalidade()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03bf85e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/editar-localidade.vue
// module id = 556
// module chunks = 0